import { createContext, useMemo, useState } from 'react';
import { useFileFormatEligible } from '@/hooks/billing/useFileFormatEligible';
import { FileFormat } from '@/types/file-format';
interface FileFormatContextProps {
  defaultFormat: FileFormat;
  fileFormat: FileFormat | null;
  setFileFormat: (fileFormat: FileFormat | null) => void;
}
interface FileFormatProviderProps {
  children: React.ReactNode;
}
const FileFormatContext = createContext<FileFormatContextProps>({
  fileFormat: null,
  setFileFormat: () => {},
  defaultFormat: FileFormat.AskEveryTime
});
FileFormatContext.displayName = 'FileFormatContext';
const FileFormatProvider = ({
  children
}: FileFormatProviderProps) => {
  const [fileFormat, setFileFormat] = useState<FileFormat | null>(null);
  const {
    defaultFormat
  } = useFileFormatEligible();
  const value = useMemo(() => ({
    fileFormat,
    setFileFormat,
    defaultFormat
  }), [fileFormat, defaultFormat]);
  return <FileFormatContext.Provider value={value} data-sentry-element="FileFormatContext.Provider" data-sentry-component="FileFormatProvider" data-sentry-source-file="FileFormatProvider.tsx">
      {children}
    </FileFormatContext.Provider>;
};
export { FileFormatContext, FileFormatProvider };